import React from 'react'

function PlayBooksIcon({ className }) {
  return (
    <svg
      className={className}
      width={'60px'}
      height={'39.9px'}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M89.06 398.1l217.1 48.4C310.7 447.5 315.3 448 320 448s9.312-.5098 13.88-1.529l217.1-48.4C565.6 394.8 576 381.8 576 366.7V39.47c0-22.15-17.99-39.46-39.31-39.46C536.2 .0127 535.9 0 535.6 0C532.7 0 522.6 1.673 320 33.13C117.1 1.63 107.4 .002 104.4 .002c-.3574 0-.6172 .0107-1.105 .0107C81.99 .0107 64 17.32 64 39.47V366.7C64 381.8 74.42 394.8 89.06 398.1zM336 63.1c0 0 195.4-30.39 200.6-31.07C540.1 32.03 544 34.91 544 39.56l-.0234 327.3L336 413.2V63.1zM96 39.56c0-2.623 1.203-4.367 2.211-5.369c.7383-.7344 2.248-1.922 5.264-2.148C108.8 32.74 304 63.1 304 63.1v350.1L96 366.7V39.56zM624 32C615.2 32 608 39.16 608 48v335.6c0 22.88-16.3 42.69-38.73 47.09L320 479.7l-249.3-48.97C48.3 426.3 32 406.5 32 383.6V48C32 39.16 24.84 32 16 32S0 39.16 0 48v335.6c0 38.13 27.16 71.14 64.58 78.5l252.3 49.58C317.9 511.9 318.1 512 320 512s2.062-.0938 3.078-.2969l252.4-49.58C612.8 454.8 640 421.8 640 383.6V48C640 39.16 632.8 32 624 32z" />{' '}
    </svg>
  )
}
export default PlayBooksIcon
